export { default as TermsPage } from "./terms";
